/**
* Created by kongwm.kong on 2017/7/21.
*/
<template>
    <div class="tip_text" v-show="tipShow!=1">
        在您开始浏览数据以及操作以前，请先撰写产品承诺函，加盖贵公司公章后上传文件，上传成功后请等待人工审核，审核通过后方可进行下一步对数据的操作。<br>
        如你在<span class="str">注册后14天内未上传承诺函，我们会将该账号进行回收。</span>
    </div>
</template>
<script>
    export default {
        props: {
            tipShow: {

            }
        }
    }

</script>
<style scoped lang="scss" type="text/scss">
    .tip_text{
        background: rgba(248,111,112,0.12);
        font-size: 14px;
        color: $c_666;
        line-height: 24px;
        padding: 30px 21px 11px;
        .str{
            color:$c_ff5;
        }
    }
</style>


// WEBPACK FOOTER //
// src/views/user/centerTip.vue